import { SpinnerOverlayComponent } from "./components/spinner-overlay/spinner-overlay.component";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { InvalidControlScrollDirective } from "./directives/invalid-control-scroll.directive";

@NgModule({
   declarations: [SpinnerOverlayComponent, InvalidControlScrollDirective],
   imports: [CommonModule, MatProgressSpinnerModule],
   exports: [SpinnerOverlayComponent, InvalidControlScrollDirective]
})
export class SharedModule {
}
